import externalPropsParser from 'services/utils/externalPropsParser';

export default function (props, parsedProps) {
    const func = () => {
        const externalProps = {};
        for (let i = 0; i < parsedProps.length; i++) {
            // eslint-disable-next-line func-names
            externalProps[`${parsedProps[i]}Computed`] = ((index) => function () {
                return externalPropsParser[`parse${props[parsedProps[index]].type.name}`](this[parsedProps[index]]);
            })(i);
        }
        return externalProps;
    };
    return {
        computed: func()
    };
}
